import React, { useState, useEffect } from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, FormControl } from '@mui/material';
import { MenuItem } from '@material-ui/core';
import adminApi from '../../assets/constants/AdminRafservice.Instance';
import CardComponent from "../../components/Cards/card";
import ExpandableGridTable from "../../components/TableGrids/ExpandableGridTable.table";
import { Box, Typography } from '@mui/material';
import { toast } from 'react-toastify';

export default function GenerateDashboardJSON() {
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        dashboard_parameter_store_name: '',
        lob: '',
        layout: '',
        slug: '',
        embedConsole: '',
        dashboard_name:'',
        dashboard_id: '',
        module:''
    });
    const [dashboardData, setDashboardData] = useState([]);
    const [JSONData, setJSONData] = useState({});
    const [jsonOpen, setJsonOpen] = useState(false); 
    const [jsonData, setJsonData] = useState(null);
    const loadDashboardData = () => {
        adminApi.get('/dashboard/dashboard_data')
            .then(res => {
                setDashboardData(res.data);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }
    const loadLatestJSONData = () => {
        adminApi.get('/dashboard/latest_json')
            .then(data => {
                setJsonData(data.data); 
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const dashboardDisplayName = formData.dashboard_name.trim();
        const formattedName = dashboardDisplayName.replace(/\s+/g, '_'); 
        const path = `/${formattedName.toLowerCase()}`; 


        const moduleName = formData.module.trim(); 
        const formattedModule = moduleName.replace(/\s+/g, '_');
        const component = formattedModule.toLowerCase() == 'data_repository' 
        ? 'DynamicDashboard' 
        : (formData.lob == 'ACA' 
            ? 'ACAQSDashboard' 
            : (formData.lob == 'Medicare' 
                ? 'MedicareQSDashboard' 
                : 'MedicaidQSDashboard')
        ); 
    
        let latestJSON = JSON.parse(localStorage.getItem('dashboardJSON')) || []; 
        const json_data = 
            {
                path: path,
                name: dashboardDisplayName,
                icon: "PersonIcon",
                component: component,
                layout: formData.layout,
                permissionSlug: formData.slug,
                lob: formData.lob,
                parameter_store_name: formData.dashboard_parameter_store_name,
                role: (formData.role).toUpperCase(),
                embedConsole: formData.embedConsole,
                module: (formattedModule).toLowerCase(),
                "isDynamic": true
            }

            latestJSON.push(json_data);

            localStorage.setItem('dashboardJSON', JSON.stringify(latestJSON));
    
            formData.json_data = latestJSON
    
        console.log("Generated JSON Data: ", JSON.stringify({ json_data }, null, 2));
    
        // Submit the data
        adminApi.post('/dashboard/create', formData)
            .then(() => {
                toast.success('dashboard added ');
                loadDashboardData();
                loadLatestJSONData()
            })
            .catch((error) => {
                toast.error("Error submitting dashboard details: ", error);
            });
    
        setOpen(false);
    };
    

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const dashboardColumn = [
        {
            name: "dashboard_name",
            label: "Dashboard Name",
        },
        {
            name: "lob",
            label: "LOB",
        },
        {
            name: "created_by",
            label: "Created By"
        },
        {
            name: "created_on",
            label: "Created At",
        },
       
        {
            name: "dashboard_parameter_store_name",
            label: "Dashboard Parameter Name",
        },
        {
            name: "role",
            label: "Role",
        },
        {
            name: "slug",
            label: "Slug",
        }
    ];

    
    useEffect(() => {
        loadDashboardData();
    }, [
    ]);
    useEffect(() => {
        loadLatestJSONData();
    }, [
    ]);
    const handleViewJSON = async () => {
        try {

          setJsonOpen(true); 
        } catch (error) {
          console.error("Error fetching JSON data", error);
        }
      };
    
      const handleJsonClose = () => {
        setJsonOpen(false);
      };

    return (
        <div>
           
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle>Generate Dashboard</DialogTitle>
                <form onSubmit={handleSubmit}>
                    <DialogContent>
                        <FormControl fullWidth margin="dense">
                            <TextField
                                label="Dashboard Parameter Name"
                                name="dashboard_parameter_store_name"
                                variant="outlined"
                                value={formData.dashboard_parameter_store_name}
                                onChange={handleChange}
                                required
                            />
                        </FormControl>
                        <FormControl fullWidth margin="dense">
                            <TextField
                                label="Dashboard Display Name"
                                name="dashboard_name"
                                variant="outlined"
                                value={formData.dashboard_name}
                                onChange={handleChange}
                                required
                            />
                        </FormControl>
                        <FormControl fullWidth margin="dense">
                            <TextField
                                label="LOB"
                                name="lob"
                                variant="outlined"
                                select
                                value={formData.lob}
                                onChange={handleChange}
                                required
                                fullWidth
                            >
                                <MenuItem value="ACA">ACA</MenuItem>
                                <MenuItem value="Medicare">Medicare</MenuItem>
                                <MenuItem value="Medicaid">Medicaid</MenuItem>
                            </TextField>
                        </FormControl>
                        <FormControl fullWidth margin="dense">
                            <TextField
                                label="layout"
                                name="layout"
                                variant="outlined"
                                value={formData.layout}
                                onChange={handleChange}
                                required
                            />
                        </FormControl>
                        <FormControl fullWidth margin="dense">
                            <TextField
                                label="Role"
                                name="role"
                                variant="outlined"
                                value={formData.role}
                                onChange={handleChange}
                                required
                            />
                        </FormControl>
                        <FormControl fullWidth margin="dense">
                            <TextField
                                label="Slug"
                                name="slug"
                                variant="outlined"
                                value={formData.slug}
                                onChange={handleChange}
                                required
                            />
                        </FormControl>
                        <FormControl fullWidth margin="dense">
                            <TextField
                                label="Module"
                                name="module"
                                variant="outlined"
                                value={formData.module}
                                onChange={handleChange}
                                required
                            />
                        </FormControl>
                        <FormControl fullWidth margin="dense">
                            <TextField
                                label="Is this Dashboard Console?"
                                name="embedConsole"
                                variant="outlined"
                                select
                                value={formData.embedConsole}
                                onChange={handleChange}
                                required
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </TextField>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button type="submit" color="primary" variant="contained">Generate Dashboard</Button>
                        <Button onClick={handleClose} variant="contained" color="grey">Cancel</Button>
                    </DialogActions>
                </form>
            </Dialog>
            {/* View JSON Dialog */}
      <Dialog open={jsonOpen} onClose={handleJsonClose} fullWidth maxWidth="lg">
        <DialogTitle>View JSON</DialogTitle>
        <DialogContent>
          <Box
            component="pre"
            sx={{
              backgroundColor: '#f4f4f4',
              padding: '16px',
              borderRadius: '4px',
              maxHeight: '400px',
              overflowY: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontFamily: 'monospace',
              fontSize: '0.875rem',
            }}
          >
            {JSON.stringify(jsonData, null, 2)} {/* Displaying the JSON data */}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleJsonClose} color="secondary" variant="contained">Close</Button>
        </DialogActions>
      </Dialog>


            <div className="container level-summary">
          <div className="row">
          {/*   <AdminSubHeader title={'Users'} userPage={true} /> */}
            <div className='col-lg-12 pr-0 pl-0'>
              <div className="list-member mt-4">
                <CardComponent
                   heading={
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      {/* <Typography variant="h6">Dashboards</Typography> */}
                      <Box ml="auto" display="flex" gap={2}> {/* Flexbox to align buttons side by side */}
                        <Button
                          color="primary"
                          onClick={handleClickOpen}
                          sx={{
                            border: '1px solid #3f51b5', // Match the label's border style
                            padding: '6px 16px',
                            borderRadius: '4px',
                            fontWeight: '500',
                            fontSize: '0.875rem',
                            textTransform: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                          }}
                        >
                          Add Dashboard Details
                        </Button>
                        <Button
                          color="secondary"
                          onClick={handleViewJSON} // Add your handler for the View JSON button
                          sx={{
                            border: '1px solid #f50057', // You can style this differently from the first button
                            padding: '6px 16px',
                            borderRadius: '4px',
                            fontWeight: '500',
                            fontSize: '0.875rem',
                            textTransform: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                          }}
                        >
                          View JSON
                        </Button>
                      </Box>
                    </Box>
                  }
                  body={
                    <>
                     {/*  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                      <Button color="primary" onClick={handleClickOpen}>Add Dashboard Details</Button>
                        </div> */}

                      <ExpandableGridTable
                        data={dashboardData}
                        columns={dashboardColumn}
                        pagination={true}
                      ></ExpandableGridTable>
                    </>
                  }
                ></CardComponent>
              </div>
            </div>
          </div>
        </div>
        </div>
    );
}
